import { useNavigate } from "react-router-dom";

export const NotificationItem = ({
  notification,
  notificationTypeMap,
  report,
  selectedNotificationTab,
}) => {
  const navigate = useNavigate();
  const notificationType =
    notificationTypeMap?.[notification?.notification_type] ?? "replied";
  const image = notification?.acting_user_avatar_template?.replace(
    "{size}",
    "100"
  );

  let title = notification?.fancy_title ?? "You have a new notification";
  let username = notification?.data?.original_username;
  let isClickable = notification?.topic_id;

  const navigateToTopic = () => {
    if (isClickable) {
      document.body.style.overflow = "unset";
      navigate(`/detail/${notification.topic_id}/${notification.post_number}`);
    }
  };

  let message = undefined;
  if (notificationType === "mentioned") {
    message = "قام بمنشنك";
  } else if (notificationType === "replied") {
    message = "قام بالرد على مشاركتك";
  } else if (notificationType === "reaction") {
    message = "تفاعل مع موضوعك";
  }
  return (
    <>
      <div
        className={`w-full flex justify-start gap-3 px-2 py-4 border-t-[1px] border-[#F1F1F1] ${
          isClickable ? "cursor-pointer" : ""
        } ${!notification?.read ? "bg-gray-100 mt-1" : ""}`}
        dir="rtl"
        onClick={navigateToTopic}
      >
        <div>
          <img
            src={image}
            alt="avatar"
            className="max-w-[30px] max-h-[30px] min-w-[30px] min-h-[30px] rounded-full"
          />
          <img
            src={`/images/header/${notificationType}.svg`}
            alt={notificationType}
            className="relative left-[14px] top-[-22px] max-w-8 max-h-8 min-w-8 min-h-8"
          />
        </div>
        <div className="overflow-hidden">
          <p
            className="text-[#333333] text-[14px] font-extrabold truncate"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </p>
          <p>
            {" "}
            {username} {message}{" "}
          </p>
          <p className="text-[#999999] text-[14px]">{notification.content}</p>
        </div>
      </div>
      {report?.length > 0 && selectedNotificationTab === "الكل"
        ? report.map((r) => (
            <div
              key={r.id}
              className={`w-full flex justify-start gap-3 px-2 py-4 border-t-[1px] border-[#F1F1F1] ${
                isClickable ? "cursor-pointer" : ""
              } ${!notification?.read ? "bg-gray-100 mt-1" : ""}`}
              dir="rtl"
              onClick={navigateToTopic}
            >
              <div>
                <img
                  src={image}
                  alt="avatar"
                  className="max-w-[30px] max-h-[30px] min-w-[30px] min-h-[30px] rounded-full"
                />
              </div>
              <div className="overflow-hidden pb-6">
                <p
                  className="text-[#333333] text-[14px] font-extrabold truncate"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {title}
                </p>
                <p>
                  {" "}
                  {r.flagger_username} {"قام بالإبلاغ عن منشورك"}{" "}
                </p>
              </div>
            </div>
          ))
        : null}
    </>
  );
};
